import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore-group/lib.helpers.resolve-props';

const getShowKbaStatus = (state) => resolveProp('identity.showKba', state);

export default createSelector(getShowKbaStatus, (showKbaStatus) => ({
    showKbaStatus,
}));
